module.exports = __webpack_public_path__ + "img/bottombg.7f7bd6aa.png";